import RecommendationItem from './model';
import create from './create';

RecommendationItem.create = create;

export default RecommendationItem;



// WEBPACK FOOTER //
// ./data/SkillRecommendation/RecommendationItem/index.js